import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AppDispatch } from "../../../../store";
import RoleModelingBox from "../../../reports-modeling/role-modeling-box";
import { useDispatch } from "react-redux";
import {
    openRoleMenuNode,
    selectModelingSelectedRole,
    addRoleMenuFolder,
    addRoleMenuNodeWithDefaultValues,
    removeMenuItemFromTree,
    addModelingRoleTreeItems,
    setModelingRoleTreeField,
    setModelingRoleOrgLevelValues,
    copyRoleMenuWithDefaultValues,
    expandItemTree,
    removeModelingRoleTreeItem,
    findPermissionInTree,
} from "../../../../reducers/administration/requestSlice";
import { getManualSelectPermissionsSearchHelp, getTransactionsSearchHelp } from "../../../../utils/searchHelps";
import { requestsService } from "../../../../services/requests-service";
import { reportsModelingService } from "../../../../services/reports-modeling-service";
import { Transaction } from "../../../../types/user-modeling/user-modeling-types";
import { TreeValue } from "../../../../types/common/modeling/modeling-types";

const RequestSingleRoleModelingBox: React.FC<{ disabled: boolean }> = ({ disabled = false }) => {
    const modelingRole = useSelector(selectModelingSelectedRole);
    const dispatch = useDispatch<AppDispatch>();
    const [searchString, setSearchString] = useState("");

    useEffect(() => {
        dispatch(
            findPermissionInTree({
                searchString,
            })
        );
    }, [searchString, dispatch]);

    // useEffect(() => {
    //     setSearchString('')
    // }, [modelingRole])

    const handleOpenRoleMenuNode = (itemPath: string[]) => {
        if (modelingRole) {
            dispatch(
                openRoleMenuNode({
                    id: modelingRole?.id,
                    itemPath,
                })
            );
        }
    };

    const handleAddRoleMenuFolder = (activeNodePath: string[], folderName: string) => {
        if (modelingRole) {
            dispatch(
                addRoleMenuFolder({
                    id: modelingRole?.id,
                    activeNodePath,
                    folderName,
                })
            );
        }
    };
    const handleAddRoleMenuNode = (activeNodePath: string[], tcodes: Transaction[]) =>
        dispatch(
            addRoleMenuNodeWithDefaultValues({
                id: modelingRole?.id,
                activeNodePath,
                tcodes,
            })
        );
    const handleRemoveRoleMenuNode = (activeNodePath: string[]) => {
        if (modelingRole) {
            dispatch(
                removeMenuItemFromTree({
                    id: modelingRole?.id,
                    menuItemPath: activeNodePath,
                })
            );
        }
    };
    const handleAddTreeItems = (items) => {
        if (modelingRole) {
            dispatch(
                addModelingRoleTreeItems({
                    id: modelingRole?.id,
                    items,
                })
            );
        }
    };
    const handleRemoveTreeItem = (path: string[]) => {
        if (modelingRole) {
            dispatch(
                removeModelingRoleTreeItem({
                    id: modelingRole?.id,
                    path,
                })
            );
        }
    };
    const handleTreeItemFieldChange = (itemPath: string[], field: string, value: TreeValue | null | boolean) => {
        if (modelingRole) {
            dispatch(
                setModelingRoleTreeField({
                    id: modelingRole?.id,
                    itemPath,
                    field,
                    value,
                })
            );
        }
    };
    const handleSetOrgLevelValues = (values: Record<string, TreeValue>) => {
        if (modelingRole) {
            dispatch(
                setModelingRoleOrgLevelValues({
                    id: modelingRole?.id,
                    values,
                })
            );
        }
    };
    const handleCopyRoleMenu = (checkedMenuItems) =>
        dispatch(
            copyRoleMenuWithDefaultValues({
                id: modelingRole?.id,
                menuToCopy: checkedMenuItems,
            })
        );

    const handleExpandItemTree = (path) =>
        dispatch(
            expandItemTree({
                path: path,
            })
        );

    const readRowsForManualSelectPermissionsSearchHelp = async (params, signal) => {
        const systemId = modelingRole?.systemId;

        params.filters.push({
            field: "systemId",
            sign: "EQ",
            value: systemId,
        });
        return getManualSelectPermissionsSearchHelp(params, signal);
    };

    const readTreeForManualSelectPermissionsSearchHelp = (params, signal, _, permissionIds) => {
        const groupId = modelingRole?.groupId;
        if (groupId) {
            return requestsService.getPfcgTreeForPermissions(groupId, permissionIds);
        }
    };

    const readManualSelectPermissionsTree = async (params, signal, permissions, checkedPermissions) => {
        const systemId = modelingRole?.systemId;

        return reportsModelingService.getTcodePermissionsTree(params, signal, systemId, permissions, checkedPermissions);
    };

    const readRowdForTransactionsSearchHelp = async (params, signal) => {
        const systemId = modelingRole?.systemId;

        params.filters.push({
            field: "systemId",
            sign: "EQ",
            value: systemId,
        });
        return getTransactionsSearchHelp(params, signal);
    };

    return (
        <RoleModelingBox
            role={modelingRole}
            onAddTreeItems={handleAddTreeItems}
            onSetOrgLevelValues={handleSetOrgLevelValues}
            onTreeItemFieldChange={handleTreeItemFieldChange}
            onOpenRoleMenuNode={handleOpenRoleMenuNode}
            onAddRoleMenuFolder={handleAddRoleMenuFolder}
            onAddRoleMenuNode={handleAddRoleMenuNode}
            onRemoveRoleMenuNode={handleRemoveRoleMenuNode}
            onCopyRoleMenu={handleCopyRoleMenu}
            onRemoveTreeItem={handleRemoveTreeItem}
            onExpandItemTree={handleExpandItemTree}
            searchString={searchString}
            setSearchString={setSearchString}
            readRowsForManualSelectPermissionsSearchHelp={readRowsForManualSelectPermissionsSearchHelp}
            readRowdForTransactionsSearchHelp={readRowdForTransactionsSearchHelp}
            readTreeForManualSelectPermissionsSearchHelp={readTreeForManualSelectPermissionsSearchHelp}
            readManualSelectPermissionsTree={readManualSelectPermissionsTree}
            disabled={disabled}
        />
    );
};
export default RequestSingleRoleModelingBox;
